import React from 'react';
import PropTypes from 'prop-types';
import ExpertReport from '../ExpertReport';
import MobileSlider from '../slider/MobileSlider';
import DesktopSlider from '../slider/v2/DesktopSlider';
import MachineInformation from '../MachineInformation';
import ImportantInformations from '../ImportantInformations';

const ContentBody = ({
  machine,
  offers,
  setGalleryContent,
  setHowToAuctionWorkModalVisible,
  setMarketPlaceModalVisible,
  setCheckBidModalData,
  minimumIncrement,
  machineSoldPrice,
  sliderMedias,
  setDownloadReportModalVisible,
  setTooltipPosition,
  reportContentsMediasGroupedByCategoryName,
}) => {
  return (
    <>
      <div className="col-15 col-lg-9">
        <MobileSlider
          medias={sliderMedias}
          setGalleryContent={setGalleryContent}
        />
        <DesktopSlider
          setGalleryContent={setGalleryContent}
          medias={sliderMedias}
          mediasGroupedByCategoryName={reportContentsMediasGroupedByCategoryName}
        />
        <ExpertReport
          setDownloadReportModalVisible={setDownloadReportModalVisible}
          report={machine.report}
          setGalleryContent={setGalleryContent}
          setTooltipPosition={setTooltipPosition}
        />
      </div>
      <div className="col-15 col-lg-6">
        <aside>
          <MachineInformation
            setHowToAuctionWorkModalVisible={setHowToAuctionWorkModalVisible}
            machine={machine}
            setMarketPlaceModalVisible={setMarketPlaceModalVisible}
            offers={offers}
            setCheckBidModalData={setCheckBidModalData}
            minimumIncrement={minimumIncrement}
            machineSoldPrice={machineSoldPrice}
          />
          <ImportantInformations machine={machine} />
        </aside>
      </div>
    </>
  );
};

ContentBody.propTypes = {
  machine: PropTypes.object,
  offers: PropTypes.array,
  setGalleryContent: PropTypes.func,
  setHowToAuctionWorkModalVisible: PropTypes.func,
  setMarketPlaceModalVisible: PropTypes.func,
  setCheckBidModalData: PropTypes.func,
  minimumIncrement: PropTypes.number,
  machineSoldPrice: PropTypes.number,
  sliderMedias: PropTypes.array,
  setDownloadReportModalVisible: PropTypes.func,
  setTooltipPosition: PropTypes.func,
  reportContentsMediasGroupedByCategoryName: PropTypes.object,
};

export default ContentBody;
